export type LabelProjectType = 'tag' | 'tag_multi' | 'classification';
export type LabelProjectFieldType = 'select' | 'text' | 'textarea' | 'date' | 'number' | 'checkbox' | 'dynamic';

export interface LabelProjectOptionalField {
    label: string;
    type: LabelProjectFieldType;
    options?: string[];
}

export interface LabelProject {
    id: string;
    name: string;
    icon?: string;
    displayName?: string;
    type: LabelProjectType;
    optionalFields?: LabelProjectOptionalField[];
    createdDate: string | number | Date;
    iterations?: string[];
}

export interface PutLabelProject {
    id: string;
    name?: string;
    icon?: string;
    displayName?: string;
    type?: LabelProjectType;
    optionalFields?: LabelProjectOptionalField[];
}

export const defaultLabelProject: LabelProject = {
    id: '',
    name: '',
    type: 'tag',
    optionalFields: [],
    createdDate: '',
};